(function (global) {
  'use strict';

  var key = 'discovery-banner-impressions-v1';
  var slots = ['hero', 'above-grid', 'inline-grid', 'empty-state'];

  function create(enabled) {
    var counts = {};
    var shown = {};
    if (enabled) {
      try {
        var stored = JSON.parse(global.sessionStorage.getItem(key) || '{}');
        if (stored && typeof stored === 'object' && !Array.isArray(stored)) counts = stored;
      } catch (_) { enabled = false; }
    }

    function count(id) {
      var value = counts[id];
      return Number.isSafeInteger(value) && value >= 0 ? value : 0;
    }

    function select(items) {
      if (!enabled || !Array.isArray(items)) return items;
      if (items.some(function (item) { return item && !['all', 'search', 'collection'].includes(item.scope); })) return items;
      var chosen = [];
      slots.forEach(function (slot) {
        var options = items.filter(function (item) { return item && item.slot === slot; });
        var targeted = options.filter(function (item) {
          return item.scope !== 'all' && typeof item.id === 'string' && (shown[item.id] || count(item.id) < 2);
        });
        var fallback = options.filter(function (item) { return item.scope === 'all'; });
        chosen = chosen.concat(targeted.length ? targeted : fallback);
      });
      return chosen;
    }

    function record(item) {
      if (!enabled || !item || item.scope === 'all' || typeof item.id !== 'string' || shown[item.id]) return;
      shown[item.id] = true;
      counts[item.id] = Math.min(2, count(item.id) + 1);
      try { global.sessionStorage.setItem(key, JSON.stringify(counts)); } catch (_) { /* Session storage may be unavailable. */ }
    }

    return { select: select, record: record };
  }

  function gridTiles(productCount, banners) {
    var tiles = Array.from({ length: productCount }, function (_, index) { return { kind: 'product', index: index }; });
    if (!productCount) return tiles;
    var placements = (banners || []).filter(function (item) { return item && item.slot === 'inline-grid'; })
      .map(function (item, index) {
        var explicit = Number.isSafeInteger(item.gridPosition) && item.gridPosition >= 1 && item.gridPosition <= 24;
        return { item: item, index: index, explicit: explicit, position: explicit ? item.gridPosition : (index + 1) * 9 };
      }).sort(function (left, right) { return left.position - right.position || left.index - right.index; });
    var lastPosition = 0;
    var duplicateOffset = 0;
    placements.forEach(function (placement) {
      var position = placement.position;
      if (!placement.explicit && placement.index === 0 && productCount < 8) position = tiles.length + 1;
      if (position > tiles.length + 1) return;
      duplicateOffset = position === lastPosition ? duplicateOffset + 1 : 0;
      tiles.splice(Math.min(position - 1 + duplicateOffset, tiles.length), 0,
        { kind: 'banner', item: placement.item });
      lastPosition = position;
    });
    return tiles;
  }

  function gridSize(banner) {
    function bounded(value, maximum) {
      return Number.isSafeInteger(value) && value >= 1 && value <= maximum ? value : 1;
    }
    var desktopColumns = bounded(banner && banner.desktopColumns, 4);
    return {
      desktopColumns: desktopColumns,
      tabletColumns: Math.min(desktopColumns, 3),
      desktopRows: bounded(banner && banner.desktopRows, 3),
      mobileColumns: bounded(banner && banner.mobileColumns, 2),
      mobileRows: bounded(banner && banner.mobileRows, 3)
    };
  }

  function applyAppearance(article, style) {
    if (!article || !style || typeof style !== 'object') return;
    var positions = ['top-left', 'top-center', 'top-right', 'middle-left', 'middle-center', 'middle-right',
      'bottom-left', 'bottom-center', 'bottom-right'];
    function position(value, device) {
      if (!positions.includes(value)) return;
      var parts = value.split('-');
      var vertical = parts[0] === 'top' ? 'flex-start' : parts[0] === 'middle' ? 'center' : 'flex-end';
      var horizontal = parts[1] === 'left' ? 'flex-start' : parts[1] === 'center' ? 'center' : 'flex-end';
      article.style.setProperty('--banner-' + device + '-vertical', vertical);
      article.style.setProperty('--banner-' + device + '-horizontal', horizontal);
      article.style.setProperty('--banner-' + device + '-align', parts[1]);
      article.dataset[device + 'TextPosition'] = value;
    }
    function color(value, name) {
      if (typeof value === 'string' && /^#[0-9a-f]{6}$/i.test(value)) article.style.setProperty(name, value);
    }
    function number(value, maximum, name, suffix) {
      if (Number.isSafeInteger(value) && value >= 0 && value <= maximum) {
        article.style.setProperty(name, value + (suffix || ''));
      }
    }
    position(style.desktopTextPosition, 'desktop');
    position(style.mobileTextPosition, 'mobile');
    color(style.headingColor, '--banner-heading-color');
    color(style.bodyColor, '--banner-body-color');
    color(style.buttonBackground, '--banner-button-background');
    color(style.buttonTextColor, '--banner-button-color');
    number(style.borderRadius, 40, '--banner-radius', 'px');
    number(style.overlayOpacity, 90, '--banner-overlay-opacity', '%');
    number(style.desktopPadding, 64, '--banner-desktop-padding', 'px');
    number(style.mobilePadding, 48, '--banner-mobile-padding', 'px');
    if (Number.isSafeInteger(style.desktopFocalX) && style.desktopFocalX >= 0 && style.desktopFocalX <= 100 &&
      Number.isSafeInteger(style.desktopFocalY) && style.desktopFocalY >= 0 && style.desktopFocalY <= 100) {
      article.style.setProperty('--banner-desktop-focal', style.desktopFocalX + '% ' + style.desktopFocalY + '%');
    }
    if (Number.isSafeInteger(style.mobileFocalX) && style.mobileFocalX >= 0 && style.mobileFocalX <= 100 &&
      Number.isSafeInteger(style.mobileFocalY) && style.mobileFocalY >= 0 && style.mobileFocalY <= 100) {
      article.style.setProperty('--banner-mobile-focal', style.mobileFocalX + '% ' + style.mobileFocalY + '%');
    }
  }

  global.DiscoveryBannerSession = { create: create, gridTiles: gridTiles, gridSize: gridSize,
    applyAppearance: applyAppearance };
}(window));
